import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Megaphone, ExternalLink } from 'lucide-react';

export default function AnnouncementBoard() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/announcements`);
      if (response.ok) {
        const data = await response.json();
        setAnnouncements(data.announcements || []);
      }
    } catch (error) {
      console.error('Error fetching announcements:', error);
    }
  };

  if (announcements.length === 0) return null;

  return (
    <div className="mb-6">
      {announcements.map((announcement) => (
        <Card key={announcement.id} className="mb-4 border-l-4 border-blue-600 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-blue-900">
              <Megaphone className="h-5 w-5" />
              {announcement.title}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">{announcement.message}</p>
            {announcement.zoom_link && (
              <a 
                href={announcement.zoom_link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-4 text-blue-600 hover:text-blue-800 font-semibold"
              >
                <ExternalLink className="h-4 w-4" />
                Join Zoom Meeting
              </a>
            )}
            <p className="text-xs text-gray-500 mt-3">{new Date(announcement.created_at).toLocaleDateString()}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
